<template>
	<div
		ref="chartContainer"
		id="chartContainer"
		style="width: 100%; height: 100%"
	></div>
</template>

<script setup>
	import {
		ref,
		onMounted,
		onBeforeUnmount,
		defineProps,
		watch,
		nextTick
	} from "vue";
	import * as echarts from "echarts";

	const chartContainer = ref(null);
	let chartInstance = null;

	const props = defineProps({
		options: {
			type: Object,
			default: () => {},
			required: true
		}
	});

	// 监听options
	watch(
		() => props.options,
		(newVal, oldVal) => {
			if (Object.keys(newVal).length > 0) {
				setTimeout(() => {
					initChart();
				}, 100);
			}
		},
		{
			immediate: true,
			deep: true
		}
	);

	const initChart = () => {
		if (chartInstance) {
			chartInstance.dispose();
			chartInstance = null;
		}

		chartInstance = echarts.init(chartContainer.value);

		chartInstance.showLoading();
		// 在这里配置你的图表选项和数据
		const options = props.options;
		chartInstance.hideLoading();
		// 使用配置项和数据绘制图表
		chartInstance.setOption(options);
	};

	// 定义防抖函数
	const debounce = (func, delay) => {
		let timerId;

		return function (...args) {
			if (timerId) {
				clearTimeout(timerId);
			}

			timerId = setTimeout(() => {
				func.apply(this, args);
				timerId = null;
			}, delay);
		};
	};

	onMounted(() => {
		chartInstance = echarts.init(chartContainer.value);
		chartInstance.showLoading();

		// 监听echartsResize事件
		window.addEventListener(
			"resize",
			() => {
				initChart();
			}
			// debounce(function () {
			// 	// 调用图表的 resize 方法
			// 	initChart();
			// }, 200)
		);
	});

	onBeforeUnmount(() => {
		if (chartInstance) {
			chartInstance.dispose();
		}
	});
</script>
